/*=========================================================================================
  File Name: moduleMapMutations.js
  Description: Map Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	UPDATE_ROUTING_TYPE(state, payload) {
		Object.assign(state, payload);
	},
	UPDATE_AVAILABLE_ROUTERS(state, payload) {
		Object.assign(state, payload);
	},
	UPDATE_TYPE_VEHICLE(state, payload) {
		Object.assign(state, payload);
	},
	SET_TYPE_VEHICLE(state, val) {
		state.typeVehicle = val;
	},
};
